import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	resetFirstLastMargins,
	resetLastMarginBottom,
} from '@/css/resources/placeholders.css';
import { transitions } from '@/css/resources/variables.css';
import {
	expandLink,
	fluidValues,
	fontStyle,
	fluidPadding,
	fluidBorderWidth,
	fluidBorderRadius,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidPadding(styles?.padding),
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,
			background: styles?.backgroundColor,
			borderColor: styles?.border?.color,

			'.supt-cardIconText__imageWrapper': {
				justifyContent: styles?.image?.alignment,
			},

			'.supt-cardIconText__image img': fluidValues(
				'maxHeight',
				styles?.image?.height?.[0],
				styles?.image?.height?.[1],
				true
			),

			'.supt-cardIconText__link': {
				marginTop: styles?.title?.typography?.margin?.top,
				marginBottom: styles?.title?.typography?.margin?.bottom,
			},

			'.supt-cardIconText__title': fontStyle({
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			}),

			'.supt-cardIconText__content p': fontStyle({
				...styles?.content?.typography,
				textAlign: styles?.content?.textAlignment,
				color: styles?.content?.color,
			}),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		borderStyle: 'solid',
		overflow: 'hidden',
		maxWidth: '100%',

		'.supt-cardIconText__imageWrapper': {
			display: 'flex',
		},

		'.supt-cardIconText__image': {
			display: 'inline-flex',
		},

		'.supt-cardIconText__link': cssObj(resetFirstLastMargins, {
			display: 'block',
			textDecoration: 'none',
		}),

		'.supt-cardIconText__title': resetFirstLastMargins,

		'.supt-cardIconText__content p': resetLastMarginBottom,

		/* with link */
		'&.supt-withLink': cssObj(expandLink(), {
			transition: `all ${transitions.mid} ease-out`,

			'.supt-cardIconText__title, .supt-cardIconText__content p': {
				transition: `all ${transitions.mid} ease-out`,
			},

			'&:hover, &:focus-within': getDynamicStyles(styles?.states?.hover),
		}),
	});

// edit
const getEditGlobalStyles = (styles) =>
	cssObj({
		'.wp-block[data-type="supt/card-icon-text"]': {
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,

			'.supt-card': {
				height: '100%',
			},

			'.supt-cardIconText__image': {
				display: 'flex',
				width: '50%',

				figure: {
					width: '100%',
				},
			},

			'.editor-post-featured-image__preview img': {
				objectFit: 'contain',
				height: '100%',
				width: '100%',
			},
		},
	});

export { getStyles, getEditGlobalStyles };
